export default "Escape Room Roskilde åbnede i juni 2020.";